export const siteMeilisearchSearchKeyKeys = {
  all: ["site-meilisearch-search-key"] as const,
  details: () => [...siteMeilisearchSearchKeyKeys.all, "detail"] as const,
  detail: (directoryToken: string) =>
    [...siteMeilisearchSearchKeyKeys.details(), directoryToken] as const,
};
